import CoreuiController from "../lib/coreui-controller"
import Alert from "../coreui/alert"

export default class CoreuiAlertController extends CoreuiController {
  static Component = Alert
}
